module.exports = __webpack_public_path__ + "static/img/content-head.fe6b39fd.png";